import { Select } from 'antd'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import { GRADES } from 'utils'


export default function useGrade(initialGrade?: string): [string | undefined, () => ReactNode] {
    const [grade, setGrade] = useState<string | undefined>(initialGrade)

    useEffect(() => {
        if (initialGrade) {
            setGrade(initialGrade)
        }
    }, [initialGrade])

    let renderer: () => ReactNode = useCallback(
        () => {
            return <Select
                value={grade ? grade : null}
                style={{ width: 150 }}
                placeholder="Select Grade"
                allowClear
                onChange={(value) => {
                    console.log(value)
                    setGrade(value)
                }}
                options={GRADES.map(t => ({ ...t }))}
            />
        },
        [grade, setGrade],
    )

    return [grade, renderer]
}